import "./form-payment.scss";
import { useFormContext } from "react-hook-form";
import { PaymentFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useQyGetProviderType } from "@factory/query/provider-type.query";
import { LabelValue } from "@shared/models/label-value.interface";
import { useCallback } from "react";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFilterContractContext } from "@domain/contract/filter-contract/filter-contract.context";
import ImageControl from "@shared/ui/hook-form/image-control/image-control";
import { Divider } from "primereact/divider";
import { currencyFormat } from "@shared/utility/formats/currency-format";

export interface FormPaymentProps {
  isBulk?: boolean;
  balance?: number;
}

type InputFormSchema = PaymentFormSchema;
export function FormPayment({ isBulk, balance }: FormPaymentProps) {
  const { control, setValue } = useFormContext<PaymentFormSchema>();
  const { getFilterEntityValues } = useFilterContractContext();
  const { provider } = getFilterEntityValues();

  const { data: provider_ } = useQyGetProviderType("", 99999);
  const providerData = provider_?.data || [];
  const options = LabelValue.MapArray(
    providerData,
    (label) => label.name || "-",
    (value) => value.code
  );

  const providerDropdownElement = useCallback(() => {
    if (provider) {
      setValue("provider", provider);
      return null;
    }

    return (
      <DropdownControl<InputFormSchema>
        control={control}
        name="provider"
        label="Provider Name"
        className="w-full md:w-full"
        options={options}
      />
    );
  }, [provider, options]);

  return (
    <div id="FormPayment" className="payment">
      <ImageControl<InputFormSchema>
        control={control}
        name="attachment"
        label="Attachment"
        imagePreviewClass="w-32 h-32"
      />

      <Divider className="" />
      <p className="text-sm text-gray-600 pb-2">
        {isBulk ? "Total Balance" : "Session Balance"}:{" "}
        <strong>{currencyFormat(balance ?? 0, "PHP")}</strong>
      </p>
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amountPaid"
        label="Amount Paid"
        className="w-full md:w-full"
        containerClassName="pb-2"
        placeholder="Enter amount paid"
      />
      {providerDropdownElement()}
    </div>
  );
}

export default FormPayment;
